module.exports = __webpack_public_path__ + "static/media/centerMatTan35.08d93ffb.png";